import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({ selector: '[cvTooltip]' })
export class TooltipDirective {
	@Input() tooltipText: string;
	@Input() disabled: boolean;
	@Input() tooltipPlacement: 'top' | 'bottom' | 'left' | 'right';
	@Input() centered: boolean;
	private tooltipEl: any;

	constructor(private el: ElementRef, private renderer: Renderer2) {
		this.tooltipText = this.tooltipText || 'cv-tooltip';
		this.tooltipPlacement = this.tooltipPlacement || 'top';
	}

	/**
	 * On mouse enter create/show the tooltip on the source element.
	 * @param $event
	 */
	@HostListener('mouseenter', ['$event'])
	onMouseEnter($event: any): void {
		if (!this.disabled) {
			this.tooltipEl = this.createTooltip();
			this.renderer.appendChild(this.el.nativeElement, this.tooltipEl);
		}
	}

	/**
	 * On mouse leave hide the tooltip.
 	 */
	@HostListener('mouseleave')
	onMouseLeave(): void {
		if (this.tooltipEl) {
			this.renderer.removeChild(this.el.nativeElement, this.tooltipEl);
		}
	}

	/**
	 * Creates the tooltip element as per bootstrap tooltip element:
	 	<div class="tooltip fade bs-tooltip-top show"
					 style="position: absolute;
						 will-change: transform;"
					 x-placement="top">
				<div class="arrow" style="left: 46px;"></div>
				<div class="tooltip-inner">Tooltip on top</div>
			</div>
	 */
	private createTooltip(): any {
		let tooltipPosition;
		if (['right', 'left'].includes(this.tooltipPlacement)) {
			tooltipPosition = 'bottom';
		} else {
			tooltipPosition = this.tooltipPlacement
		}

		const tooltip = this.renderer.createElement('div');
		this.renderer.addClass(tooltip, 'tooltip');
		this.renderer.addClass(tooltip, 'fade');
		this.renderer.addClass(tooltip, `bs-tooltip-${tooltipPosition}`);
		const arrow = this.renderer.createElement('div');
		this.renderer.addClass(arrow, 'arrow');
		this.renderer.setStyle(arrow, 'left', '5px');
		const tooltipInner = this.renderer.createElement('div');
		this.renderer.setStyle(tooltipInner, 'max-width', '100%');
		this.renderer.addClass(tooltipInner, 'tooltip-inner');
		this.renderer.setProperty(tooltipInner, 'innerHTML', this.tooltipText);
		// const text = this.renderer.createText(this.tooltipText);
		// this.renderer.appendChild(tooltipInner, text);
		this.renderer.appendChild(tooltip, arrow);
		this.renderer.appendChild(tooltip, tooltipInner);
		// Calculate tooltip placement (top or bottom) based on parent element
		const top = this.el.nativeElement.offsetTop;
		let left = this.el.nativeElement.offsetLeft;
		const height = this.el.nativeElement.clientHeight;
		if (this.centered) {
			left = left + (this.el.nativeElement.offsetWidth ? (this.el.nativeElement.offsetWidth / 2) : 0);
		}
		const toolTipTop = (this.tooltipPlacement === 'top' ? top - height : top + height);
		this.renderer.setStyle(tooltip, 'top', `${ toolTipTop }px`);
		this.renderer.setStyle(tooltip, 'left', `${ left }px`);
		this.renderer.addClass(tooltip, 'show');
		return tooltip;
	}
}
